module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jrHp29/tc-custom/9781449474515.jpg?1716662595340",
      "alt": "This image is the cover for the book Zits Apocalypse"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Zits Apocalypse\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Teenagers are a lot like zombies--slow-moving, difficult to communicate with, and always, always hungry. Luckily,"), _c('i', [_vm._v(" Zits Apocalypse")]), _vm._v(" is here to shed some light on the ups, downs, and in-betweens of parenting teens. Join the Duncan family--Connie, Walt, and Jeremy--as they grapple with modern technology, confront an endless sea of dirty laundry, and learn to bridge the cultural divide between parents and teenagers."), _c('br'), _c('br'), _c('i', [_vm._v("Zits Apocalypse")]), _vm._v(" offers a light-hearted yet insightful look at the multifaceted lives of modern teens and their families, complemented with annotations from the creators. From financial trouble to the perils of young love, this collection broaches relevant and familiar topics with with, wit, humor, and affection.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jerry Scott, Jim Borgman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0